<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button  (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Select a payment type</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding">
    <ion-note>
      This is for tracking purposes only. If you want to accept in-person payments, you can use your existing Square account and link it to your salonMonster account.
    </ion-note>
  </div>
  <ion-list>
    <ion-item *ngFor='let payment of paymentTypes' (click)='onPaymentSelect(payment)' [disabled]="disableCashButton && payment.type == 1" tappable>
      {{ payment.name }}
    </ion-item>
  </ion-list>
</ion-content>


<ion-footer *ngIf="!dismissSetupFooter">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismissSetup()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-grid>
    <ion-row>
      <ion-col size="4">
        <div class="ion-text-center ion-margin">
          <img src="../../../../assets/images/wisepos-floating-tall.png" alt="card-reader" height="120"/>
        </div>
      </ion-col>
      <ion-col class="ion-padding set-up-text">
        <h4>Set up integrated payments in less than 5 minutes</h4>
        <div>
          Get no-show protection with cards on file, transparent rates and no monthly fees. <a routerLink="settings/payment-processing-settings"  color="primary">Learn more</a>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>